import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Filter, SearchService } from '@docpath/linces-angular-components';
import { DpSection, HeaderAction, SearchBasicInfo, SearchMode, SearchOptionType, SearchRowInfo } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';

import { IndexService } from '../../models/index-service';
import { IndexServicesService } from '../../services/index-services.service';
import { IndexServicesTableService } from '../table/index-services-table.service';
import { IndexServicesHeaderService } from './index-services-header.service';


@Component({
  selector: 'app-index-services-header',
  templateUrl: './index-services-header.component.html'
})
export class IndexServicesHeaderComponent implements OnChanges, OnInit, OnDestroy {

  @Input() indexServices: IndexService[] = [];

  @Output() filtersChanged = new EventEmitter<Filter[]>();

  private readonly title = 'services-config.index-services.title';
  section = new DpSection({ name: 'index-services', rows: [], header: this.title, tooltip: this.title });
  showSearch = false;

  rightActions: HeaderAction[] = [];
  leftActions: HeaderAction[] = [];

  searchAvailableOptions: SearchRowInfo[] = [
    new SearchRowInfo(true, 'name', undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true),
    new SearchRowInfo(false, 'url', undefined, SearchOptionType.TEXT_FULL, SearchMode.exactly, true, true)
  ];

  private filters: Filter[] = [];
  private indexServicesChangedSubscription?: Subscription;

  constructor(
    private readonly indexServicesHeaderService: IndexServicesHeaderService,
    private readonly indexServicesTableService: IndexServicesTableService,
    private readonly indexServicesService: IndexServicesService,
    private readonly searchService: SearchService
  ) {
    this.rightActions = this.indexServicesHeaderService.getRightActions();
    const searchAction = this.indexServicesHeaderService.getSearchAction(this.rightActions);

    searchAction.action = () => {
      this.showSearch = !this.showSearch;
    };

  }

  ngOnInit(): void {
    if (!this.indexServicesChangedSubscription) {
      this.indexServicesChangedSubscription = this.indexServicesService.indexServicesChanged.subscribe(() => {
        this.leftActions = [];
      });
    }
  }

  ngOnDestroy(): void {
    if (this.indexServicesChangedSubscription) {
      this.indexServicesChangedSubscription.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // eslint-disable-next-line dot-notation
    if (changes['indexServices']) {
      this.leftActions = this.indexServicesHeaderService.getLeftActions(this.indexServices);
    }
  }

  isSearchVisible(): boolean {
    return this.showSearch;
  }

  clearSearch(): void {
    this.filters = [];
    this.filtersChanged.emit(this.filters);
    this.indexServicesTableService.loadIndexServices(this.filters, 1);
    this.leftActions = [];
  }

  sendSearch(currentFilters: Array<SearchBasicInfo>): void {
    this.filters = this.searchService.toFilters(currentFilters);
    this.filtersChanged.emit(this.filters);
    this.indexServicesTableService.loadIndexServices(this.filters, 1);
    this.leftActions = [];
  }

  hideSearch(): void {
    this.showSearch = false;
  }

}
